import moment from "moment";

import {
  ReopenableReview,
  isAnonymous,
} from "@apps/assessments/components/reopen-review-numbers";
import useLabel from "@apps/use-label/use-label";
import Avatar from "@components/avatar/avatar";
import UserComboboxDeactivatedIcon from "@components/user-combobox/user-combobox-deactivated-icon";

/**
 * One Reopen menu option for a peer or upward review.
 * An anonymous review gives no writer to an admin or a manager,
 * so the option names the review by its number and submit date instead.
 * A writer who left the organization is no readable user, but the review still names them.
 */
const ReopenReviewOptionLabel = ({
  assessmentType,
  review,
  submittedDatetime,
  number,
}: {
  assessmentType: "Peer" | "Upward";
  review: ReopenableReview & { responderDeactivated?: boolean | null };
  submittedDatetime?: string | null;
  number?: number;
}) => {
  const label = useLabel();
  const reviewLabel = label("review", { capitalize: true });

  if (isAnonymous(review)) {
    const submitted = submittedDatetime
      ? ` · submitted ${moment(submittedDatetime).format("D MMM")}`
      : "";
    return (
      <div className="flex items-center">
        <div className="mr-2 font-medium">Reopen:</div>
        <div>{`${assessmentType} ${reviewLabel}${number ? ` ${number}` : ""}${submitted}`}</div>
      </div>
    );
  }

  return (
    <div className="flex items-center">
      <div className="mr-2 font-medium">{`Reopen ${assessmentType} ${reviewLabel} for:`}</div>
      {review.responder && <Avatar user={review.responder} size={4} />}
      <div className="ml-1">
        {review.responder?.name ?? review.responderName}
      </div>
      {review.responderDeactivated && <UserComboboxDeactivatedIcon />}
    </div>
  );
};

export default ReopenReviewOptionLabel;
